import cn from 'classnames';

import { IConDefaultType } from '..';
import AprilFoolsDark from '../../assets/eventLogo/april_fools_dark.svg?react';
import AprilFoolsLight from '../../assets/eventLogo/april_fools_light.svg?react';

export enum EventLogoIconVariant {
  APRIL_FOOLS = 'APRIL_FOOLS',
}

interface IEventLogoIconProps extends IConDefaultType {
  variant?: EventLogoIconVariant;
  width?: number;
  height?: number;
}

function EventLogoIcon({
  className,
  rotate,
  width,
  height,
  color,
  flip,
  variant = EventLogoIconVariant.APRIL_FOOLS,
  style,
}: IEventLogoIconProps) {
  const isDarkMode = localStorage.getItem('theme') === 'dark';

  return (
    <>
      {variant === EventLogoIconVariant.APRIL_FOOLS && (
        <i
          className={cn('dds-icon', className, { flip })}
          style={{
            width,
            minWidth: width,
            height,
            transform: `rotate(${rotate}deg)`,
            ...style,
          }}
        >
          {isDarkMode ? (
            <AprilFoolsDark width={width} height={height} />
          ) : (
            <AprilFoolsLight width={width} height={height} />
          )}
        </i>
      )}
    </>
  );
}

export default EventLogoIcon;
